import initialState from '../../../../store/initialState';
import * as types from '../services/strategicdemandactionType';

const strategicdemandReducer = (state = initialState.strategicDemand, action) => {
  switch (action.type) {

    /* =========================
       Volume Trend Reports (DD)
       ========================= */
    case types.FETCH_VOLUME_TREND_REPORTS_DD_REQUEST:
      return { ...state, isLoadingVolumeTrendReportsDD: true, volumeTrendReportsDD: [], volumeTrendReportsDDError: null };

    case types.FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS:
      return { ...state, isLoadingVolumeTrendReportsDD: false, volumeTrendReportsDD: Array.isArray(action.payload?.values) ? action.payload.values : Array.isArray(action.payload?.values?.reportsDDList) ? action.payload.values.reportsDDList : [], volumeTrendReportsDDError: null };

    case types.FETCH_VOLUME_TREND_REPORTS_DD_FAILURE:
      return { ...state, isLoadingVolumeTrendReportsDD: false, volumeTrendReportsDDError: action.payload };

    /* =========================
       Strategic Reports Tab
       ========================= */
    case types.FETCH_STRATEGIC_REPORTS_TAB_REQUEST:
      return { ...state, isStrategicDemandPlannerLoading: true, strategicDemandPlannerReports: [], totalReportsCount: 0, reportsTabError: null };

    case types.FETCH_STRATEGIC_REPORTS_TAB_SUCCESS:
      return { ...state, isStrategicDemandPlannerLoading: false, strategicDemandPlannerReports: action.payload?.values || [], totalReportsCount: action.payload?.recordsTotal || 0, reportsTabError: null };

    case types.FETCH_STRATEGIC_REPORTS_TAB_FAILURE:
      return { ...state, isStrategicDemandPlannerLoading: false, strategicDemandPlannerReports: [], totalReportsCount: 0, reportsTabError: action.payload };

    /* =========================
       Delete Strategic Report
       ========================= */
    case types.DELETE_STRATEGIC_DEMAND_REPORT_REQUEST:
      return { ...state, isStrategicDemandPlannerLoading: true, reportsTabError: null };

    case types.DELETE_STRATEGIC_DEMAND_REPORT_SUCCESS:
      return { ...state, isStrategicDemandPlannerLoading: false, strategicDemandPlannerReports: state.strategicDemandPlannerReports.filter(report => report.BlockPlanningDemandTableID !== action.payload), reportsTabError: null };

    case types.DELETE_STRATEGIC_DEMAND_REPORT_FAILURE:
      return { ...state, isStrategicDemandPlannerLoading: false, reportsTabError: action.payload };

    /* =========================
       Update Block Planning Note
       ========================= */
    case types.UPDATE_BLOCK_PLANNING_REPORT_NOTE_REQUEST:
      return { ...state, isStrategicDemandPlannerLoading: true };

    case types.UPDATE_BLOCK_PLANNING_REPORT_NOTE_SUCCESS:
      return { ...state, isStrategicDemandPlannerLoading: false, updateNoteSuccess: true };

    case types.UPDATE_BLOCK_PLANNING_REPORT_NOTE_FAILURE:
      return { ...state, isStrategicDemandPlannerLoading: false, updateNoteError: action.payload };
    /* =========================
       Reset / Common Flags
       ========================= */
    case types.RESET_STRATEGIC_DEMAND_FLAGS:
      return { ...state, updateNoteSuccess: false, deleteSuccess: false, draftSuccess: false, publishSuccess: false, draftError: null, publishError: null, demandInputReports: [], demandInputTotalCount: 0, isDemandInputLoading: false, demandInputError: null, demandInputFilters: { lstRPCE: [], lstWorklist: [], lstPractice: [], lstDayType: [] }, siteLegend: null };

    /* =========================
       Block Capacity Table
       ========================= */
    case types.FETCH_BLOCK_CAPACITY_TABLE_REPORT_REQUEST:
      return { ...state, isBlockCapacityTableReportLoading: true, blockCapacityTableReportResponse: null };

    case types.FETCH_BLOCK_CAPACITY_TABLE_REPORT_SUCCESS:
      return { ...state, isBlockCapacityTableReportLoading: false, blockCapacityTableReportResponse: action.payload };

    case types.FETCH_BLOCK_CAPACITY_TABLE_REPORT_FAILURE:
      return { ...state, isBlockCapacityTableReportLoading: false, blockCapacityTableReportResponse: null, blockCapacityTableReportError: action.payload };

    /* =========================
       Block Planning Demand Input
       ========================= */
    case types.FETCH_BLOCK_PLANNING_DEMAND_INPUT_REQUEST:
      return { ...state, isDemandInputLoading: true, demandInputReports: [], demandInputTotalCount: 0 };

    case types.FETCH_BLOCK_PLANNING_DEMAND_INPUT_SUCCESS:
      return { ...state, isDemandInputLoading: false, demandInputReports: action.payload?.values || [], demandInputTotalCount: action.payload?.recordsTotal || 0 };

    case types.FETCH_BLOCK_PLANNING_DEMAND_INPUT_FAILURE:
      return { ...state, isDemandInputLoading: false, demandInputError: action.payload };

    /* =========================
       Demand Input Filters
       ========================= */
    case types.FETCH_DEMAND_INPUT_FILTER_DD_REQUEST:
      return { ...state, isDemandInputFilterDDLoading: true, demandInputFilterDDError: null };

    case types.FETCH_DEMAND_INPUT_FILTER_DD_SUCCESS:
      return { ...state, isDemandInputFilterDDLoading: false, demandInputFilters: action.payload?.values || { lstRPCE: [], lstWorklist: [], lstPractice: [], lstDayType: [] } };

    case types.FETCH_DEMAND_INPUT_FILTER_DD_FAILURE:
      return { ...state, isDemandInputFilterDDLoading: false, demandInputFilterDDError: action.payload };

    /* =========================
       Site Onboarding Legend
       ========================= */
    case types.FETCH_ONBOARDING_SITE_LEGEND_REQUEST:
      return { ...state, isSiteLegendLoading: true, siteLegend: null };

    case types.FETCH_ONBOARDING_SITE_LEGEND_SUCCESS:
      return { ...state, isSiteLegendLoading: false, siteLegend: action.payload };

    case types.FETCH_ONBOARDING_SITE_LEGEND_FAILURE:
      return { ...state, isSiteLegendLoading: false, siteLegendError: action.payload };

    /* =========================
       Draft Demand Planning
       ========================= */
    case types.DRAFT_BLOCK_DEMAND_PLANNING_REQUEST:
      return { ...state, isDraftSaving: true, draftSuccess: false, draftError: null };

    case types.DRAFT_BLOCK_DEMAND_PLANNING_SUCCESS:
      return { ...state, isDraftSaving: false, draftSuccess: true };

    case types.DRAFT_BLOCK_DEMAND_PLANNING_FAILURE:
      return { ...state, isDraftSaving: false, draftError: action.payload };

    /* =========================
       Publish Demand Planning
       ========================= */
    case types.PUBLISH_BLOCK_DEMAND_PLANNING_REQUEST:
      return { ...state, isPublishSaving: true, publishSuccess: false, publishError: null };

    case types.PUBLISH_BLOCK_DEMAND_PLANNING_SUCCESS:
      return { ...state, isPublishSaving: false, publishSuccess: true };

    case types.PUBLISH_BLOCK_DEMAND_PLANNING_FAILURE:
      return { ...state, isPublishSaving: false, publishError: action.payload };
    case types.FETCH_WORKLIST_BY_RPCE_DEMAND_REQUEST:
      // return { ...state, isWorklistLoading: true, demandInputFilters: { ...state.demandInputFilters, lstWorklist: [] } };
      return { ...state, isWorklistLoading: true, RPCEDATA: [] };


    case types.FETCH_WORKLIST_BY_RPCE_DEMAND_SUCCESS:
      // return { ...state, isWorklistLoading: false, demandInputFilters: { ...state.demandInputFilters, lstWorklist: action.payload?.values || action.payload || [] } };
      return { ...state, isWorklistLoading: false, RPCEDATA: action.payload?.WorkListDropdownItems || [], };


    case types.FETCH_WORKLIST_BY_RPCE_DEMAND_FAILURE:
      // return { ...state, isWorklistLoading: false, worklistError: action.error };
      return { ...state, isWorklistLoading: false, RPCEDATA: [] };

    case types.FETCH_PRACTICE_BY_WORKLIST_REQUEST:
      return {
        ...state, isPracticeLoading: true, demandInputFilters: { ...state.demandInputFilters, lstPractice: [] }
      };

    case types.FETCH_PRACTICE_BY_WORKLIST_SUCCESS:
      return {
        ...state, isPracticeLoading: false, demandInputFilters: {
          ...state.demandInputFilters, lstPractice: action.payload?.Practices || [] // ✅ FIXED
        }
      };

    case types.FETCH_PRACTICE_BY_WORKLIST_FAILURE:
      return {
        ...state, isPracticeLoading: false, demandInputFilters: { ...state.demandInputFilters, lstPractice: [] }
      };

    case types.FETCH_SITE_ONBOARDING_PLANNER_REQUEST:
      return { ...state, isSiteOnboardingLoading: true, siteOnboardingPlannerResponse: [] };

    case types.FETCH_SITE_ONBOARDING_PLANNER_SUCCESS:
      return { ...state, isSiteOnboardingLoading: false, siteOnboardingPlannerResponse: action.payload };

    case types.FETCH_SITE_ONBOARDING_PLANNER_FAILURE:
      return { ...state, isSiteOnboardingLoading: false, siteOnboardingPlannerResponse: [], siteOnboardingError: action.error };
    case types.FETCH_SITE_OFFBOARDING_PLANNER_REQUEST:
      return { ...state, isSiteOffboardingLoading: true };

    case types.FETCH_SITE_OFFBOARDING_PLANNER_SUCCESS:
      return {
        ...state, isSiteOffboardingLoading: false, siteOffboardingPlannerResponse: action.payload
      };

    case types.FETCH_SITE_OFFBOARDING_PLANNER_FAILURE:
      return {
        ...state, isSiteOffboardingLoading: false, siteOffboardingPlannerResponse: null, siteOffboardingError: action.error
      };
    case types.FETCH_BLOCK_PLANNING_DEMAND_DAILY_REQUEST:
      return {
        ...state,
        isDemandDailyLoading: true,
        demandDailyError: null,
      };

    case types.FETCH_BLOCK_PLANNING_DEMAND_DAILY_SUCCESS:
      return {
        ...state,
        isDemandDailyLoading: false,
        demandDailyData: action.payload?.values || [],
        demandDailyTotalCount: action.payload?.recordsTotal || 0,
      };

    case types.FETCH_BLOCK_PLANNING_DEMAND_DAILY_FAILURE:
      return {
        ...state,
        isDemandDailyLoading: false,
        demandDailyData: [],
        demandDailyTotalCount: 0,
        demandDailyError: action.error,
      };
    case types.FETCH_DEMAND_QUARTERLY_REQUEST:
      return { ...state, isDemandQuarterlyLoading: true };

    case types.FETCH_DEMAND_QUARTERLY_SUCCESS:
      return {
        ...state,
        isDemandQuarterlyLoading: false,
        demandQuarterlyData: action.payload?.values || [],
        demandQuarterlyTotalCount: action.payload?.recordsTotal || 0,
      };

    case types.FETCH_DEMAND_QUARTERLY_FAILURE:
      return {
        ...state,
        isDemandQuarterlyLoading: false,
        demandQuarterlyError: action.error,
      };

    case types.EXPORT_STRATEGIC_REPORTS_REQUEST:
      return { ...state, isExportLoading: true };
    case types.EXPORT_STRATEGIC_REPORTS_SUCCESS:
      return { ...state, isExportLoading: false, };
    case types.EXPORT_STRATEGIC_REPORTS_FAILURE:
      return { ...state, isExportLoading: false, };

      case types.FETCH_WEEK_OR_QUARTER_REQUEST:
      return { ...state, isWeekOrQuarterLoading: true };
    case types.FETCH_WEEK_OR_QUARTER_SUCCESS:
      return { ...state, isWeekOrQuarterLoading: false, weekOrQuarterData: action.payload?.values || [] };
    case types.FETCH_WEEK_OR_QUARTER_FAILURE:
      return { ...state, isWeekOrQuarterLoading: false, weekOrQuarterData: []};

    /* =========================
       Default
       ========================= */
    default:
      return state;
  }
};
export default strategicdemandReducer;